import useStore from "../../../store"
import formatter from '../../../constants/currencyFormatter'
import AlertMessage from '../../common/AlertMessage'
import { useTranslation } from 'react-i18next'
import { showUtilizationPercentage } from "../../../utilities/featureFlags"
import { SolidGreenButton } from "../../common/Buttons"
import { useIsMobile } from "../../../hooks/useIsMobile"
import { useNavigate } from "react-router-dom"

export default function CreditAvailable() {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const navigate = useNavigate()

  const dealer = useStore((state) => state.dealer)
  const percentage = dealer?.attributes["total-credit-remaining"] / dealer?.attributes["total-credit"] * 100
  const isSuspended = dealer?.attributes['active-status'] === 'Suspended'

  return (
    <div>
      <div
        className={`font-black text-2xl mt-1 pl-2 lg:pl-2 ${isSuspended && 'text-yellow'}`}
        data-testid="credit-available"
      >
        {formatter.format(dealer?.attributes['total-credit-remaining'])}
        {showUtilizationPercentage && <span className="text-sm text-grey-300"> / {formatter.format(dealer?.attributes['total-credit'])}</span>}
      </div>
      {showUtilizationPercentage &&
        <div
          className={`pl-3 text-sm text-grey-300 ${isSuspended && 'text-yellow'}`}
          data-testid="percent-available"
        >
          {`${percentage.toFixed(2)}% ${t('Available')}`}
        </div>
      }
      {isSuspended &&
        <AlertMessage
          message="Please contact your Account Manager immediately"
          style="justify-center text-yellow !text-base"
        />
      }
      {!isMobile &&
        <SolidGreenButton
          text={t('Request Floor')}
          onClick={() => navigate('/blackbook')}
          style="w-full my-2"
          data-testid="request-floor-button"
        />
      }
    </div>
  )
}